@if (!hasResult) {
  <app-advisor-errorpage></app-advisor-errorpage>
}
@if (hasResult) {
  <div>
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="headline cell small-12 large-12">
        @if (anfrage?.programs?.length > 0) {
          <span [innerHTML]=anfrage?.programs?.length></span>
        }
        <h1 [innerHTML]="(textkeyPrefix + '.headline' + (anfrage?.programs?.length === 0 ? '.none' : isBundOnly? '.bund' : '')) | translate: placeholder"></h1>
      </div>
    </div>
    @if (isFossilEnergy) {
      <div class="cell attention-callout">
        <app-advisor-image path="/foc/foc-attention.svg"></app-advisor-image>
        <div class="attention-teaser">
          <h2 [innerHTML]="textkeyPrefix + '.attention.callout.fossil.' + fossilEnergyProgram + '.headline' | translate"></h2>
          <p [innerHTML]="textkeyPrefix + '.attention.callout.fossil.' + fossilEnergyProgram + '.text' | translate"></p>
          @if (mocUrl) {
            <a class="button signal2 inline-arrow-right" [href]="mocUrl" target="_blank" [innerHTML]="textkeyPrefix + '.attention.callout.button' | translate"></a>
          }
        </div>
      </div>
    }
    @if (!(this.isFossilEnergy && this.anfrage?.programs?.length === 0) && internalPortal) {
      <app-honeypot [anfrage]="anfrage" [clickTarget]="idTargetElement"></app-honeypot>
    }
    @if ((anfrage?.programs?.length > 0 && internalPortal) || !internalPortal) {
      <div class="cell programs">
        <h2 id="funding-programs" class="text-center" [innerHTML]="textkeyPrefix + '.programs.headline' | translate: placeholder"></h2>
        <p [innerHTML]="textkeyPrefix + '.programs.text' | translate"></p>
        @if(forceDialog || showDownload) {
          <dialog-hint [clickTarget]="measuresWithoutProgram.length <= 0 ? idTargetElement : null"
            [showPdfAndPrintIcons]="measuresWithoutProgram.length <= 0"
            [textkey]="(textkeyPrefix + '.callout' + (measuresWithoutProgram.length > 0 ? '.no.programs' : '')) | translate: placeholder"
          [closable]="true"></dialog-hint>
        }
        @if (anfrage?.programs?.length > 1 && (objectKeys(toggleMeasure)?.length > 1 || objectKeys(toggleFundingType).length > 1)) {
          <div class="filter">
            <h3 [innerHTML]="textkeyPrefix + '.sortierung.headline' | translate"></h3>
            <button type="button" class="filter" aria-controls="filter" [attr.aria-expanded]="toggleFilter" [attr.aria-label]="'arialabel.toggle.filter' | translate" (click)="onClickToggleFilter()"><i class="icon-chevron-down" [class.open]="toggleFilter" [class.close]="!toggleFilter"></i></button>
            @if (toggleFilter) {
              <div id="filter" class="filter-content">
                @if (objectKeys(toggleFundingType).length > 1) {
                  <p class="funding-types" [innerHTML]="textkeyPrefix + '.sortierung.art' | translate"></p>
                }
                @for (fundingType of objectKeys(toggleFundingType); track fundingType) {
                  <button type="button" role="radio" aria-controls="programs-table" [attr.aria-expanded]="toggleFundingType[fundingType]"
                    class="sort-funding-type" (click)="toggleSelectedFundingType(fundingType)">
                    <span class="custom-radio" [class.checked]="toggleFundingType[fundingType]"></span>
                    <span [innerHTML]="(textkeyPrefix + '.art.' + fundingType) | translate"></span>
                  </button>
                }
                @if (visiblePrograms?.length > 0 && objectKeys(toggleMeasure)?.length > 1) {
                  <div>
                    <p class="all-measures" [innerHTML]="textkeyPrefix + '.sortierung.massnahmen' | translate"></p>
                    @for (selectedMeasure of objectKeys(toggleMeasure); track selectedMeasure) {
                      <button type="button" role="radio" aria-controls="programs-table"  [attr.aria-expanded]="toggleMeasure[selectedMeasure]"
                        class="selected-measures" (click)="toggleSelectedMeasure(selectedMeasure)">
                        <span class="custom-radio" [class.checked]="toggleMeasure[selectedMeasure]"></span>
                        <span [innerHTML]="(textkeyPrefix + '.massnahme.' + selectedMeasure) | translate"></span>
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (showForMediumUp) {
          <table [id]="showForMediumUp ? 'programs-table' : null" [attr.aria-hidden]="!showForMediumUp" [attr.aria-live]="!showForMediumUp ? 'polite' : null">
            <tr>
              @if (showForLargeOnly) {
                <th [innerHTML]="textkeyPrefix + '.foerdermittel.foerdergeber' | translate"></th>
              }
              <th [innerHTML]="textkeyPrefix + '.foerdermittel.programm' | translate"></th>
              @if (showForMediumUp) {
                <th [innerHTML]="textkeyPrefix + '.foerdermittel.art' | translate"></th>
              }
              <th [innerHTML]="textkeyPrefix + '.foerdermittel.massnahmen' | translate"></th>
            </tr>
            @for (program of getVisibleItems(); track program) {
              <tr>
                @if (showForLargeOnly) {
                  <td [innerHTML]="program.foerdergeber_name"></td>
                }
                <td [innerHTML]="program.name"></td>
                @if (showForMediumUp) {
                  <td>
                    <span class="funding-type" [innerHTML]="(textkeyPrefix + '.art.' + program.art) | translate"></span>
                  </td>
                }
                <td>
                  @for (category of program.categories; track category) {
                    @if (toggleMeasure[category] === true || toggleMeasure.hasOwnProperty(category) === false) {
                      <span class="category" [innerHTML]="(textkeyPrefix + '.massnahme.' + category) | translate"></span>
                    }
                  }
                </td>
              </tr>
            }
          </table>
        }
        @if (!showForMediumUp) {
          <table [id]="!showForMediumUp ? 'programs-table' : null" [attr.aria-hidden]="showForMediumUp" [attr.aria-live]="!showForMediumUp ? 'polite' : null">
            @for (program of getVisibleItems(); track program) {
              <tbody >
                <tr>
                  <th [innerHTML]="textkeyPrefix + '.foerdermittel.programm' | translate"></th>
                </tr>
                <tr>
                  <td [innerHTML]="program.name"></td>
                </tr>
                <tr>
                  <th [innerHTML]="textkeyPrefix + '.foerdermittel.art' | translate"></th>
                </tr>
                <tr>
                  <td><span class="funding-type" [innerHTML]="(textkeyPrefix + '.art.' + program.art) | translate"></span></td>
                </tr>
                <tr>
                  <th [innerHTML]="textkeyPrefix + '.foerdermittel.massnahmen' | translate"></th>
                </tr>
                <tr>
                  <td>
                    @for (category of program.categories; track category) {
                      @if (toggleMeasure[category] === true || toggleMeasure.hasOwnProperty(category) === false) {
                        <span class="category" [innerHTML]="(textkeyPrefix + '.massnahme.' + category) | translate"></span>
                      }
                    }
                  </td>
                </tr>
              </tbody>
            }
          </table>
        }
        @if (visiblePrograms.length <= 0 && anfrage?.programs?.length > 0) {
          <h3 [innerHTML]="textkeyPrefix + '.no.visible.programs' | translate"></h3>
        }
        @if (visiblePrograms.length > 0) {
          <app-pagination clickTarget="funding-programs" [itemCount]="countVisiblePrograms" [itemsPerPage]="itemsPerPage"
          (onPageChange)="updateStartIndex($event)" ariaControlsTarget="programs-table"></app-pagination>
        }
      </div>
    }
    @if (showDownload) {
      <div class="cell small-12">
        <app-download [id]="idTargetElement" [url]="reportUrl" textkeyPrefix="foerdermittelcheck.ergebnis."></app-download>
      </div>
    }
    @if (forceDialog && anfrage?.programs?.length > 0) {
      <app-dialogform [id]="idTargetElement" textkeyPrefix="foerdermittelcheck" advisorImagePath="/foc/foc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="reportUrl"></app-dialogform>
    }
    @if (mocUrl) {
      <app-advisor-teaser [url]="mocUrl" [mailUrl]="mocUrl" [textPrefix]="textkeyPrefix + '.teaser.moc'" image="/foc/moc-teaser.svg"></app-advisor-teaser>
    }
    @if (sdcUrl) {
      <app-advisor-teaser [url]="sdcUrl" [mailUrl]="sdcUrl" [textPrefix]="textkeyPrefix + '.teaser.sdc'" image="/foc/sdc-teaser.svg" changeColumnOrder="true"></app-advisor-teaser>
    }
    @if (wpcUrl) {
      <app-advisor-teaser [url]="wpcUrl" [mailUrl]="wpcUrl" [textPrefix]="textkeyPrefix + '.teaser.wpc'" image="/foc/wpc-teaser.svg"></app-advisor-teaser>
    }
    @if (forceDialog && anfrage?.programs?.length <= 0 && !isFossilEnergy) {
      <app-dialogform [id]="idTargetElement" textkeyPrefix="foerdermittelcheck" advisorImagePath="/foc/foc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="reportUrl"></app-dialogform>
    }
    <app-portal-teaser></app-portal-teaser>
    @if (internalPortal === true) {
      <app-donate [textkeyPrefix]="textkeyPrefix"></app-donate>
    }
  </div>
}

@if (hasResult) {
  <div class="grid-x grid-padding-x">
    <div class="cell">
      <app-step-buttons [previousLink]="previousLink"
        mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
      previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
    </div>
  </div>
}
